// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDatafrmOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDatafrmOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDatafrmOutlined = function DrrpDatafrmOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDatafrmOutlinedSvg
  }));
};

DrrpDatafrmOutlined.displayName = 'DrrpDatafrmOutlined';
export default React.forwardRef(DrrpDatafrmOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDatafrmOutlined.js
// module id = 2541
// module chunks = 0